<template>
    <div class="mobileNav" >
        <slot name="button">
            <button class="mobileNav__button openMobileButton" :class="buttonClass" @click="open">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" stroke-width="3" stroke="currentColor" fill="currentColor" >
                    <title>Open Menu</title>
                    <path d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 
                    12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 
                    160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z" />
                </svg>
            </button>
        </slot>
        <nav ref="menu" class="mobileNav__menu" >
            <slot v-bind:isMenuOpen="isMenuOpen" />
        </nav>
    </div>
</template>
<script>
import Vue from 'vue'
import MmenuLight from 'mmenu-light'


const focusableElements = () => [
    "a",
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
]

export default {
    menu: null,
    navigator: null,
    drawer: null,
    data() {
        return {
            isMenuOpen: false,
            focusable: [],
        }
    },
    props: {
        title: {
            type: String,
        },
        mediaQuery: {
            type: String,
        },
        buttonClass: {
            type: String,
            default: 'button -primary -ghost',
        },
        navigationOptions: {
            type: Object,
            default() {
                return {
                    title: this.title,
                }
            },
        },
        offcanvasOptions: {
            type: Object,
            default() {
                return {
                    position: 'left'
                }
            },
        }
    },

    methods: {
        /**
         * Unfortunately this is not reactive; but still here for convienence.
         */
        isOpen() {
            return this.$options.drawer.wrapper.matches('.mm-ocd--open')
        },

        onKeyDown(event) {
            if (event.key === 'Escape' && this.isOpen()) {
                this.close();
            }

            if (event.key === 'Enter' && event.target.classList.contains('close-button') && this.isOpen()) {
                this.close();
                document.querySelector('.siteHeader__content').focus()
            }

            if (event.key === 'Tab' && this.isOpen()) {
                const firstEl = this.focusable[0]
                const lastEl = this.focusable[this.focusable.length - 1]

                if (!event.shiftKey && document.activeElement === lastEl) {
                    firstEl.focus()
                    return event.preventDefault()
                }

                if (event.shiftKey && document.activeElement === firstEl) {
                    lastEl.focus()
                    event.preventDefault()
                }
            }
        },

        closeButton(event){
            if (event.target.classList.contains('close-button') && this.isOpen()) {
                this.close();
            }
        },

        open() {
            this.$options.drawer.open()
            this.focusable[0].focus()
            this.isMenuOpen = !this.isMenuOpen
        },

        close() {
            this.$options.drawer.close()
            this.isMenuOpen = !this.isMenuOpen
        },
    },

    mounted() {
        this.$options.menu = new MmenuLight(this.$refs.menu, this.mediaQuery)
        this.$options.navigator = this.$options.menu.navigation(this.navigationOptions)
        this.$options.drawer = this.$options.menu.offcanvas(this.offcanvasOptions)

        this.focusable = this.$refs.menu.querySelectorAll( focusableElements() )

        document.addEventListener('keydown', this.onKeyDown)

        document.querySelector('.close-icon').addEventListener('click', this.close)
    }
}
</script>
